import "../menu/menu.css";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";

function Menu() {
  function toApplication () {
    console.log("ok");
    const element = document.getElementsByClassName('sectionTitle')[0];
    element.scrollIntoView({
      behavior: 'smooth'
    })
  }
  function toTeam () {
    console.log("ok");
    const element = document.getElementsByClassName('sectionTitle')[1];
    element.scrollIntoView({
      behavior: 'smooth'
    })
  }
  function toPartner () {
    console.log("ok");
    const element = document.getElementsByClassName('sectionTitle')[2];
    element.scrollIntoView({
      behavior: 'smooth'
    })
  }
  function toAmbition () {
    console.log("ok");
    const element = document.getElementsByClassName('sectionTitle')[3];
    element.scrollIntoView({
      behavior: 'smooth'
    })
  }
  return (
    <div className="menu">
      <div className="menuSub">
        <div className="column">
          <div className="row">
            <div className="logo" />
            <div className="menuCategories">
              <button className="column" onClick={toApplication}>Application</button>
            </div>
            <div className="menuCategories">
              <button className="column" onClick={toTeam}>Equipe</button>
            </div>
            <div className="menuCategories">
              <div className="menuText column" onClick={toPartner}>Devenir partenaire</div>
            </div>
            <div className="menuCategories">
              <div className="menuText column" onClick={toAmbition}>Ambition</div>
            </div>
            <Link to="/download" className="downloadButton">
              <div className="column">Télécharger</div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;